import todoicon from "../assets/img/todoicon.jpeg";
import budgetapp from "../assets/img/budgetapp.jpeg";
import shoppingCart from "../assets/img/ShoppingCart.jpeg";

function CubeLink({ href, children, ...props }) {
  const path = window.location.pathname;
  return (
    <a className={path === href ? "active" : ""} href={href} {...props}>
      {children}
    </a>
  );
}

function Cubes() {
  return (
    <>
      <div className="container text-center text-dark pt-5">
        <div className="row">
          <h1>Welcome</h1>
          <p>
            Welcome to my React Portfolio, I will be demonstrating my
            proficiency in front-end development and user-centric design. This
            React Built Site, offers a seamless, responsive, and visually
            experience that displays my understanding of dynamic web
            applications, React's component-based architecture, responsive user
            interfaces, state management, and modern development practices.
          </p>
          <p>
            Its clean and efficient code base reflects my commitment to writing
            scalable, reuseable and maintainable code. I invite you to explore
            the apps below to witness firsthand my dedication to crafting
            user-friendly interfaces and leveraging the latest web technologies
            to deliver a polished digital experience.
          </p>
        </div>
        <div className="row">
          <div className="card-sm col shadow-lg">
            <img
              src={todoicon}
              className="img-thumbnail w-25"
              alt="todo icon"
            ></img>
            <div className="card-body">
              <h5 className="card-title">ToDo App</h5>
              <p className="card-text m-0">
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </p>
              <CubeLink
                className="btn btn-primary"
                href="/ReactSite/ToDoApp/ToDoApp"
              >
                View
              </CubeLink>
            </div>
          </div>

          <div className="card-sm col shadow-lg">
            <img src={budgetapp} className="img-thumbnail w-25" alt="..."></img>
            <div className="card-body">
              <h5 className="card-title">Budget Allowcation App</h5>
              <p className="card-text m-0">
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </p>
              <CubeLink
                href="/ReactSite/BudgetApp/BudgetApp"
                className="btn btn-primary m-2"
              >
                View
              </CubeLink>
            </div>
          </div>

          <div className="card-sm col shadow-lg">
            <img
              src={shoppingCart}
              className="img-thumbnail w-25"
              alt="..."
            ></img>
            <div className="card-body">
              <h5 className="card-title">Shopping Cart</h5>
              <p className="card-text m-0">
                Some quick example text to build on the card title and make up
                the bulk of the card's content.
              </p>
              <CubeLink
                href="https://saltirewebsites.com/ReactShoppingCart/"
                className="btn btn-primary m-2"
              >
                View
              </CubeLink>
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row p-4 gap-4 py-md-5 align-items-center justify-content-center">
            <div
              className="dropdown-menu position-static d-flex flex-column flex-lg-row align-items-stretch justify-content-start p-3 rounded-3 shadow-lg"
              data-bs-theme="light"
            >
              <nav className="col-lg-8">
                {" "}
                <div className="row">
                  <h4>My React Learning Path </h4>
                </div>
                <ul className="list-unstyled d-flex flex-column gap-2">
                  <li>
                    <svg className="bi" width="24" height="24"></svg>
                    <div>
                      <strong className="d-block">Main product</strong>
                      <small>Take a tour through the product</small>
                    </div>
                  </li>
                  <li>
                    <svg className="bi" width="24" height="24"></svg>
                    <div>
                      <strong className="d-block">Another product</strong>
                      <small>Explore this other product we offer</small>
                    </div>
                  </li>
                  <li>
                    <svg className="bi" width="24" height="24"></svg>
                    <div>
                      <strong className="d-block">Support</strong>
                      <small>Get help from our support crew</small>
                    </div>
                  </li>
                </ul>
              </nav>
              <div className="d-none d-lg-block vr mx-4 opacity-10">&nbsp;</div>
              <hr className="d-lg-none"></hr>
              <div className="col-lg-auto pe-3">
                <nav>
                  <ul className="d-flex flex-column gap-2 list-unstyled small">
                    <li>
                      <CubeLink className="btn btn-success" href="/ReactSite/">
                        Documentation
                      </CubeLink>
                    </li>
                    <li>
                      <CubeLink className="btn btn-success" href="/ReactSite/">
                        Use cases
                      </CubeLink>
                    </li>
                    <li>
                      <CubeLink className="btn btn-success" href="/ReactSite/">
                        API status
                      </CubeLink>
                    </li>
                    <li>
                      <CubeLink className="btn btn-success" href="/ReactSite/">
                        Partners
                      </CubeLink>
                    </li>
                    <li>
                      <CubeLink className="btn btn-success" href="/ReactSite/">
                        Resources
                      </CubeLink>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cubes;
